import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";
import moment from "moment";

const defaultRender = (value) => (value ? value : " ");

const formatDateTime = (dateTime) => {
    return moment(dateTime).format('DD-MM-YYYY HH:mm:ss');
};
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value).toFixed(decimalPlaces);
};


const usePendingOrderCell = () => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { symbols } = useSelector(state => state.watchlist)
    const getDigitsBySymbolId = (symbolId) => {
        return symbols?.[symbolId]?.digits;
    };

    return React.useMemo(() => ([
        { title: t("id"), dataIndex: 'id', width: 70 ,render: defaultRender, },
        { title: t("time"), dataIndex: 'dateTime',width: 140, render: (value) => formatDateTime(value), },
        { title: t('type'), dataIndex: 'side',width: 60, render: (side) => (side === 1 ? t('buy') : t('sell')), },
        { title: t('amount'), dataIndex: 'amount',width: 100, render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('symbol'), dataIndex: 'symbolName', width: 100,render: (value, row) => symbols?.[row.symbolId]?.name || '-', },

        {
            title: t('price'), dataIndex: 'price', width: 120, render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            }
        },
        { title: t('currentPrice'), dataIndex: 'currentPrice', width: 140, render: (value, row) => row?.side == -1 ? <BidValue symbolId={row.symbolId} digits={row.digits} /> : <AskValue symbolId={row.symbolId} digits={row.digits} />, },
        {
            title: t('s/l'), dataIndex: 'stopLoss', width: 80, render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            }
        },
        {
            title: t('t/p'), dataIndex: 'takeProfit', width: 80, render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            }
        },
        { title: t("comment"), dataIndex: "comment", width: 100,render: defaultRender },
    ]));
};

export default usePendingOrderCell;
